import { c as _c } from "react/compiler-runtime";
import React from "react";
export type PannableViewerProps = React.PropsWithChildren<{
  /** Ref for the transform element; useViewerPan controls transform directly */
  transformRef: React.RefObject<HTMLDivElement | null>;
}>;

/**
 * Wrapper that applies pan/zoom transform. The transform is controlled
 * directly by useViewerPan via the ref—no store subscription.
 */
export const PannableViewer: React.FC<PannableViewerProps> = t0 => {
  const $ = _c(4);
  const {
    children,
    transformRef
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      minHeight: "100%",
      transformOrigin: "0 0",
      transform: "translate(0, 0) scale(1)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== transformRef) {
    t2 = <div ref={transformRef} style={t1}>{children}</div>;
    $[1] = children;
    $[2] = transformRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};